import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AiService {
  constructor(private http: HttpClient) {}

  generateScenario(prompt: string, scored: number, feedback: number) {
    const payload = {
      prompt,
      scored,
      feedback,
    };
    return this.http.post<any>(
      environment.apiUrl + '/generate_scenario',
      payload,
      {
        observe: 'response',
      }
    );
  }

  getCreditsUsed(): Observable<any[]> {
    return this.http
      .get<any>(environment.apiUrl + '/ai_credits', {
        responseType: 'json',
      })
      .pipe(
        map((responseData) => {
          return responseData._embedded.ai_credits[0];
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        })
      );
  }

  generateQuiz(
    topic: string,
    num_questions: number,
    difficulty: string,
    question_types: any
  ) {
    const payload = {
      topic,
      num_questions,
      difficulty,
      question_types,
    };
    return this.http.post<any>(environment.apiUrl + '/generate_quiz', payload, {
      observe: 'response',
    });
  }

  generateChat(
    subject: string,
    num_stems: number,
  ) {
    const payload = {
      subject,
      num_stems,
    };
    return this.http.post<any>(environment.apiUrl + '/generate_chat', payload, {
      observe: 'response',
    });
  }
}
